<template>
  <div class="index-container" :class="{
    isMobile: isMobile()
  }">
    <!-- banner -->
    <div class="banner-box">
      <el-carousel class="banner-carousel">
        <el-carousel-item class="banner-item" :key="index" v-for="(item, index) in bannerList">
          <img class="img-common" :src="item.cover" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 我们的项目 -->
    <div class="bg-color">

      <div class="common-block our-project sys-max-width">
        <indexBlockTitle
          title="我们的项目"
          en="Public Welfare Project"
        />

        <div class="sys-max-width">
          <div class="grid lg-mx lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-6">
            <!--          <div @click="goDetail(item)" :key="index" v-for="(item, index) in ourProjectList" class="item bg-white rounded-lg shadow-md overflow-hidden">-->
            <div @click="goProjectPage()" :key="index" v-for="(item, index) in ourProjectList" class="item bg-white rounded-lg shadow-md overflow-hidden">
              

              <div class="bottom-content p-7">
                <div class="top-title flex items-center">
                  <div class="icon rounded-full">
                    <img v-if="Array.isArray(item.logo) && item.logo.length > 0" class="img-common" :src="item.logo[0].url">
                  </div>

                  <div class="title-right">
                    <div
                      class="z-title"
                      style="color: #0A1121; font-weight: bold; font-size: 18px"
                    >
                      {{ item.titleZh_cn }}
                    </div>
                    <div
                      class="f-title"
                      style="color: #878A95; font-size: 15px"
                    >
                      {{ item.titleEn }}
                    </div>
                  </div>
                </div>

                <div class="desc">{{ item.introduction }}</div>
              </div>

              <div class="top-img">
                <img v-if="Array.isArray(item.image) && item.image.length > 0" class="img-common" :src="item.image[0].url">
              </div>

              <div v-html="item.imgText" class="flex items-baseline justify-center bottom-info">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 基金会动态 -->
    <div class="common-block jjh-dynamic sys-max-width">
      <indexBlockTitle
        title="基金会动态"
        en="Foundation News"
      />

      <div class="sys-max-width">
        <div class="lg-mx">
          <newsBlock :dataInfo="item" :key="index" v-for="(item, index) in indexNewsList"/>
        </div>
      </div>
    </div>

    <!-- 推进项目 -->
    <div class="bg-image-2">

      <div class="common-block advance-project sys-max-width">
        <indexBlockTitle
          title="推进项目"
          en="Advance The Project"
        />

        <div class="sys-max-width">

          <div class="lg-mx">

            <div class="advance-box flex items-start">
              <div class="left-block" @click="goDetail(advanceProjectFirstInfo)">
                <div class="img overflow-hidden rounded-lg">
                  <img v-if="advanceProjectFirstInfo.cover" class="img-common" :src="advanceProjectFirstInfo.cover.url" alt="">
                </div>

                <div class="title">{{ advanceProjectFirstInfo.title }}</div>

                <div class="desc line-clamp-3">{{ advanceProjectFirstInfo.summary }}</div>
              </div>

              <div class="right-block">
                <div @click="goDetail(item)" :key="index" v-for="(item, index) in advanceProjectList.slice(1)" class="item flex items-center">
                  <div class="left-img overflow-hidden rounded-lg">
                    <img v-if="item.cover" class="img-common" :src="item.cover.url" alt="">
                  </div>

                  <div class="right-content">
                    <div class="title">{{ item.title }}</div>

                    <div class="desc line-clamp-3">
                      {{ item.summary }}
                    </div>
                  </div>
                </div>

                <div class="ad-pro-more" @click="$router.push({name: welfareData.router})">查看更多</div>
                <!-- <el-button @click="$router.push({name: welfareData.router})">查看更多</el-button> -->
              </div>
            </div>

          </div>


        </div>
      </div>

    </div>

    <!-- 公益缘起 -->
    <div class="common-block our-teams sys-max-width">
      <indexBlockTitle
        title="公益缘起"
        en="origin of public welfare"
      />

      <div class="sys-max-width">
        <div class="grid lg-mx lg:grid-cols-2 grid-cols-1 gap-6">
          <div class="item left-us">

            <!-- <div class="top-banner">
              <el-carousel class="yq-banner" :interval="6000">
                <el-carousel-item>
                  <img class="img-common" src="~@/assets/yq.png" />
                </el-carousel-item>
                <el-carousel-item>
                  <img class="img-common" src="~@/assets/jj2.jpg" />
                </el-carousel-item>
              </el-carousel>
            </div> -->

            <!-- 团队人员介绍 -->
            <div class="top-banner">
              <div id="us-swiper" class="swiper-container">
                <div class="swiper-wrapper">
                  <div :key="index" v-for="(item, index) in teamList" class="swiper-slide flex items-center justify-center">
                    <div class="circle flex items-center justify-center">
                      <div class="img overflow-hidden">
                        <img class="img-common" :src="item.cover" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div @click="swiperPrev" class="common swiper-prev el-icon-arrow-left"></div>
              <div @click="swiperNext" class="common swiper-next el-icon-arrow-right"></div>
            </div>

            <div class="bottom-text">
              <div class="icon"></div>
              <div class="name">{{ currentTeamItemInfo.name }}</div>
              <div v-if="currentTeamItemInfo.introduce">
                <div :key="index" v-for="(item, index) in currentTeamItemInfo.introduce" class="content">{{ item.desc }}</div>
              </div>
            </div>
          </div>

          <div class="item right-video">
            <!-- <div id="video-box"></div> -->
            <video class="video" controls controlsList="nodownload" oncontextmenu="return(false)" :src="teamVideoUrl"></video>
          </div>

        </div>

      </div>
    </div>

    <!-- 信息公开 -->
    <div class="bg-image-3">

      <div class="common-block info-block">
        <indexBlockTitle
          :title="infoData.name"
          en="Information Exposed"
        />

        <div class="sys-max-width">
          <div class="grid lg:grid-cols-3 grid-cols-1 gap-6">
            <div @click="$router.push({name: 'info-detail', params: {id: item.id}})" :key="index" v-for="(item, index) in infoModuleList" class="top-item lg:m-0 lg:shadow-none mb-6 mx-6 bg-white rounded-xl shadow-lg cursor-pointer">
              <div class="flex-center">
                <div class="top-icon w-40 h-40 rounded-full flex-center">
                  <!-- <img class="w-20 h-20 block" :src="`~@/assets/info1.png`" alt=""> -->
                  <div :class="`w-20 h-20 block img${index + 1}`"></div>
                </div>
              </div>

              <hr class="line" />

              <div class="text-2xl text-center mb-7">{{ item.name }}</div>

              <div class="text-lg leading-8" style="color: #606266; margin-bottom: 42px;">{{ item.remark }}</div>

              <div class="more primary-color flex-center">
                <div style="margin-right: 8px;">查看更多</div>
                <div class="el-icon-arrow-right"></div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <!-- 合作机构 -->
    <div class="bg-image-1">

      <div class="common-block teamwork-block">
        <indexBlockTitle
          title="合作机构"
          en="Cooperative Organization"
        />

        <div class="sys-max-width">
          <div class="item-box grid lg-mx lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-4">
            <div class="item" :key="index" v-for="(item, index) in orgList">
              <img class="img-common" :src="item.cover" alt="">
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'

import { MODULE_CONFIG } from '@/config/index'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'
import indexBlockTitle from '@/components/indexBlockTitle'
import newsBlock from '@/components/newsBlock'

import { fetchCustomList } from '@/api/common'
import { isMobile } from '@/utils/index'

export default {
  components: {
    indexBlockTitle,
    newsBlock
  },

  data() {
    return {

      swiper: null,

      bannerList: [],

      orgList: [],

      advanceProjectFirstInfo: {},
      advanceProjectList: [],

      ourProjectList: [],
      teamList: [],
      teamVideoUrl: '',
      currentTeamItemInfo: {}
    }
  },
  computed: {
    ...mapGetters({
      indexNewsList: 'indexNewsList'
    }),

    infoData() {
      return this.$store.getters.getModuleItemById(MODULE_CONFIG.INFO)
    },
    infoModuleList() {
      return this.$store.getters.getSecondModuleById(MODULE_CONFIG.INFO)
    },

    welfareData() {
      return this.$store.getters.getModuleItemById(MODULE_CONFIG.WELFARE)
    },

  },
  methods: {
    isMobile,
    swiperPrev() { // 后退
      let target = this.swiper.activeIndex

      if (target === 3) {
        target = this.teamList.length + 2
      } else {
        target = target - 1
      }

      console.log(target)

      this.swiper.slideTo(target)
    },
    swiperNext() { // 前进
      let target = this.swiper.activeIndex

      if (target === this.teamList.length + 2) {
        target = 3
      } else {
        target = target + 1
      }

      console.log(target)

      this.swiper.slideTo(target)
    },

    goDetail(item) {
      this.$router.push({
        name: 'contentDetail',
        query: {
          moduleId: item.pid,
          moduleSecId: item.cate_id,
          contentId: item.object_code
        }
      })
    },

    goProjectPage() {
      this.$router.push({ name: 'publicWelfare' })
    },

    async getBannerList() {
      try {
        const { contents } = await fetchCustomList({
          action: 'banner',
          type: 1
        })

        try {
          this.bannerList = JSON.parse(contents)
        } catch (error) {
          console.log(error)
        }
      } catch (error) {

      }
    },

    async getOrganizationList() {
      try {
        const { contents } = await fetchCustomList({
          action: 'partner',
          type: 1
        })

        try {
          this.orgList = JSON.parse(contents)

          console.log(this.orgList)
        } catch (error) {
          console.log(error)
        }
      } catch (error) {

      }
    },

    async getAdvanceProjectList() {
      try {
        const { data } = await fetchCustomList({
          action: 'doing_projects',
          type: 2
        })

        if (data.length > 0) {
          this.advanceProjectFirstInfo = data[0]
        }

        this.advanceProjectList = data
      } catch (error) {

      }
    },

    async getOurProjectList() {
      try {
        const { contents } = await fetchCustomList({
          action: 'projects',
          type: 2
        })

        this.ourProjectList = JSON.parse(contents)
      } catch (error) {

      }
    },

    async getTeamList() {
      try {
        const { contents } = await fetchCustomList({
          action: 'team',
          type: 1
        })

        try {
          const { teamList, teamVideoUrl } = JSON.parse(contents)

          this.teamList = teamList
          this.teamVideoUrl = teamVideoUrl

          this.$nextTick(() => {
            this.initSwiper()
          })
        } catch (error) {
          console.log(error)
        }
      } catch (error) {

      }
    },

    initSwiper() {
      this.swiper = new Swiper('#us-swiper', {
        slidesPerView: 3,
        centeredSlides: true,
        loop: true
      })
    }
  },
  watch: {
    'swiper.realIndex': {
      handler(newVal, oldValue) {
        console.log('newVal', newVal)
        console.log('oldValue', oldValue)
        this.currentTeamItemInfo = this.teamList[newVal] || {}
      },
      deep: true
    }
  },
  created() {
    this.getBannerList()
    this.getOrganizationList()

    this.getAdvanceProjectList()

    this.getOurProjectList()

    this.getTeamList()

  }
}
</script>

<style lang="scss">
.index-container {

  &.isMobile {
    .banner-box {
      .banner-carousel {
        height: 195px;
      }
    }

    .common-block {
      // &.jjh-dynamic {
      //   .sys-max-width {
      //     .lg-mx {

      //       .item {
      //         display: block;

      //         .left-date {
      //           display: none;
      //         }

      //         .right-content {
      //           display: block;
                

      //           .left-img {
      //             width: 100%;
      //             margin-bottom: 20px;
      //           }

      //           .right-content {
      //             height: 200px;

      //             .desc {
      //               margin-bottom: 0;
      //             }
      //             .btn {
      //               // text-align: center;
      //               // position: relative;
      //               left: 50%;
      //               transform: translateX(-50%);
      //             }
      //           }

                
      //         }
      //       }
      //     }
      //   }
      // }

      &.advance-project {
        .sys-max-width {
          .lg-mx {
            .advance-box {
              display: block;
              .left-block {
                width: 100%;
                margin: 0 0 40px 0;
              }

              .right-block {
                padding-bottom: 10px;

                .ad-pro-more {
                  margin: 0 auto;
                }
              }
            }
          }
        }
      }

      &.our-teams {
        .sys-max-width {
          .lg-mx {
            .left-us {
              width: 100%;
              margin-bottom: 0px;

              .bottom-text {
                padding: 24px 0;

                .content {
                  padding: 0 40px;
                }
              }
            }


          }
        }
      }

      &.info-block {
        background-color: #F4F7FC;

        .title {
          color: #0A1121;
        }
      }

      &.teamwork-block {
        padding-bottom: 30px;
        .sys-max-width {
          .lg-mx.item-box  { 
            margin-bottom: 0;
          }
        }
      }
    }
  }


  .banner-box {
    .banner-carousel {
      height: 420px;
    }
    .el-carousel__container {
      height: 100%;
    }
    .banner-item {
      height: 100%;
    }
  }
  
  .common-block {
    position: relative;
    padding-top: 60px;

    &.advance-project {
      .left-block {
        width: 500px;
        margin: 0 42px 40px 0;
        cursor: pointer;
        flex-shrink: 0;

        .img {
          height: 280px;
          margin-bottom: 22px;
        }

        .title {
          font-size: 18px;
          font-weight: normal;
          color: #0A1121;
          margin-bottom: 15px;
        }

        .desc {
          font-size: 14px;
          font-weight: normal;
          color: #606266;
          line-height: 20px;
        }
      }

      .right-block {
        flex-grow: 1;

        .ad-pro-more {
          width: 125px;
          height: 44px;
          background: url(~@/assets/more-bg.png) no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          text-align: center;
          line-height: 44px;
          font-size: 14px;
          color: #FFFFFF;
        }

        .item {
          margin-bottom: 29px;
          cursor: pointer;

          .left-img {
            width: 224px;
            height: 126px;
            margin-right: 20px;
            flex-shrink: 0;
            // background-color: $primary;
          }

          .right-content {
            flex-grow: 1;
            .title {
              font-size: 18px;
              font-weight: normal;
              color: #0A1121;
              margin-bottom: 16px;
            }

            .desc {
              font-size: 14px;
              font-weight: normal;
              color: #606266;
              line-height: 20px;
            }
          }
        }

        .more {

        }
      }
    }

    &.jjh-dynamic {
      margin-bottom: 50px;
    }

    &.our-project {
      .item {
        // height: 60px;
        // background-color: red;
        margin-bottom: 40px;
        cursor: pointer;
        transition: all .2s;

        &:hover {
          transform: translateY(-4px);
        }

        .top-img {
          height: 140px;
        }

        .bottom-content {
          .top-title {
            margin-bottom: 30px;

            .icon {
              width: 60px;
              height: 60px;
              margin-right: 16px;
              flex-shrink: 0;
            }
          }

          .title-right {
            flex-grow: 1;
          }

          .large {
            height: 96px;
          }

          .desc {
            font-size: 14px;
            font-weight: normal;
            color: #606266;
            line-height: 24px;
            height: 48px;
            // margin-bottom: 30px;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;

            @media (min-width: 768px) {
              & {
                -webkit-line-clamp: 4;
                height: 96px;
              }
            }
          }

          
        }

        .bottom-info {
          padding: 23px 0;
          color: #606266;
          font-size: 14px;

          p {
            color: #FF0000;
            font-size: 30px;
            font-weight: bold;
          }
        }
      }
    }

    &.our-teams {
      .item {
        margin-bottom: 40px;

        &.left-us {
          width: 502px;

          .top-banner {
            padding: 0 40px;
            margin-bottom: 20px;
            position: relative;

            // .yq-banner {
            //   .el-carousel__indicators {
            //     .el-carousel__button {
            //       background-color: $primary;
            //     }
            //   }
            // }

            .swiper-wrapper {
              // position: relative;
              .swiper-slide {
                .circle {
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  background-color:#F1F5FB;

                  .img {
                    border: 1px solid #fff;
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                    // background-color: chartreuse;
                  }
                }
              }


            }

            .common {
              position: absolute;
              top: 50%;
              font-size: 20px;
              cursor: pointer;
              transform: translateY(-50%);

              &.swiper-prev {
                left: 0
              }

              &.swiper-next {
                right: 0
              }
            }
          }



          .bottom-text {
            height: 152px;
            background: linear-gradient(90deg, #1296DB, #026DB1);
            border-radius: 10px;
            padding: 16px 0;
            text-align: center;
            position: relative;

            .icon {
              height: 0px;
              width: 0px;
              border-right: 10px solid transparent;
	            border-left: 10px solid transparent;
              border-bottom: 10px solid #1296DB;
              position: absolute;
              top: -10px;
              left: 50%;
              /*left: 110px;*/
              transform: translateX(-50%);
            }

            .name {
              font-size: 18px;
              font-weight: normal;
              color: #FFFFFF;
              margin-bottom: 10px;
            }

            .content {
              padding: 0 80px;
              font-size: 14px;
              font-weight: normal;
              color: #FFFFFF;
              line-height: 20px;
            }
          }


        }

        &.right-video {
          // background-color: $primary;
          // height: 312px;
          border-radius: 10px;
          overflow: hidden;
          video {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    &.info-block {
      // background: url(http://cloud.changanfoundation.com/202104111653296615.png) no-repeat;
      // background-size: 100% 100%;
      .title {
        color: #fff;
      }
      .top-item {
        padding: 26px 39px 36px;
        margin-bottom: 40px;
        .top-icon {
          // width: 120px;
          // height: 120px;
          background-color: #E5ECF5;

          .img1 {
            background: url(~@/assets/info1.png) no-repeat;
            background-size: 100% 100%;
          }

          .img2 {
            background: url(~@/assets/info2.png) no-repeat;
            background-size: 100% 100%;
          }

          .img3 {
            background: url(~@/assets/info3.png) no-repeat;
            background-size: 100% 100%;
          }

          .more {
            // color: ;

          }
        }
      }

      hr {
        border-color: rgba($color: #0A1121, $alpha: 0.1);
        border-top-width: 1px;
        margin-top: 22px;
        margin-bottom: 22px;
      }
    }

    &.teamwork-block {
      min-height: 380px;

      .item-box {
        margin-bottom: 93px;

        .item {
          height: 68px;
          // background-color: $primary;
        }
      }
    }

  }

  .bg-color {
    background-color: #F4F7FC;
  }
  .bg-image-1 {
    background: url(~@/assets/bg-image-1.jpg) no-repeat;
    background-size: 100% 100%;
  }
  .bg-image-2 {
    background: url(~@/assets/bg-image-2.jpg) no-repeat;
    background-size: 100% 100%;
  }
  .bg-image-3 {
    background: url(~@/assets/bg-image-3.jpg) no-repeat;
    background-size: 100% 100%;
  }
}
</style>
